import { useSelector } from "react-redux";

export const useSuperTracks = () => {
  const { superTracks } = useSelector(({ superTracks }) => superTracks);

  function hasNoIntersection(track1, track2) {
    if (
      track1.frame_end < track2.frame_start ||
      track1.frame_start > track2.frame_end
    ) {
      return true; // No intersection
    } else {
      return false; // Intersection exists
    }
  }

  function checkIntersectionBetweenArrays(array1, array2) {
    for (let i = 0; i < array1.length; i++) {
      for (let j = 0; j < array2.length; j++) {
        if (!hasNoIntersection(array1[i], array2[j])) {
          return false; // Intersection exists
        }
      }
    }
    return true; // No intersection found
  }

  const hasIntersection = ({ targetId, superTrackId }) => {
    if (!superTracks[targetId] || !superTracks[superTrackId]) return false;

    const { tracks } = superTracks[targetId];
    const { tracks: incomingTracks } = superTracks[superTrackId];
    const intersectionExists = !checkIntersectionBetweenArrays(
      tracks,
      incomingTracks
    );
    return intersectionExists;
  };

  return {
    hasIntersection,
  };
};
